import useTakerMarkets from '@/enterprise/data/useTakerMarkets';
import useFeature from '@/lib/features';

const useEnableLendingConnections = () => {
  const { data: takerMarkets } = useTakerMarkets();
  const makerOrgUuids = new Set(takerMarkets.map((tm) => tm.makerOrganizationUuid) ?? []);
  const [feature] = useFeature('enterprise-ui_enableLendingConnectionsIntegration', {
    makerOrgUuids: Array.from(makerOrgUuids),
  });
  return feature;
};

export default useEnableLendingConnections;
